import { DataGridPro, DataGridProProps } from '@mui/x-data-grid-pro';
export const DataGridComponent: React.FC<DataGridProProps> = ({
  columns,
  rows,
  pageSize,
  rowsPerPageOptions,
  pagination,
  apiRef,
  components,
  initialState,
  columnVisibilityModel,
  density,
  className,
  componentsProps,
  onPageSizeChange,
  onColumnVisibilityModelChange,
  onSelectionModelChange,
  onStateChange,
  selectionModel,
  rowCount,
  page,
  onPageChange
}) => {
  return (
    <DataGridPro
      apiRef={apiRef}
      rows={rows}
      columns={columns}
      disableSelectionOnClick
      checkboxSelection
      onSelectionModelChange={onSelectionModelChange}
      checkboxSelectionVisibleOnly={true}
      pageSize={pageSize}
      onPageSizeChange={onPageSizeChange}
      page={page}
      onPageChange={onPageChange}
      rowsPerPageOptions={rowsPerPageOptions}
      pagination={pagination}
      disableColumnSelector={false}
      components={components}
      initialState={initialState}
      columnVisibilityModel={columnVisibilityModel}
      onColumnVisibilityModelChange={onColumnVisibilityModelChange}
      componentsProps={componentsProps}
      className={className}
      density={density ? density : 'standard'}
      onStateChange={onStateChange}
      selectionModel={selectionModel}
      rowCount={rowCount}
      paginationMode="server"
    />
  );
};
